// @flow

export type Noop = 'bravissimo/api/NOOP';
export type CallApi = 'bravissimo/api/CALL_API';

export const CALL_API: CallApi = 'bravissimo/api/CALL_API';
export const NOOP: Noop = 'bravissimo/api/NOOP';
